import { useMemo } from "react"
import { useParams, Outlet } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { useUserQuery } from "features/api"
import { getAccountSettingsTabsConfig } from "helpers/config/tabs/accountSettingsTabsConfig"
import LinkTabsSection from "widgets/common/LinkTabsSection"
import PageTitle from "widgets/common/PageTitle"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

const AccountSettings = () => {
  const { t } = useTranslation()
  const { username } = useParams()

  useDocumentTitle(t("pageTitles.ACCOUNT_SETTINGS"))

  const accountSettingsTabsConfig = useMemo(() => getAccountSettingsTabsConfig(), [])
  const {
    data: user,
    isError: isErrorUser,
    isLoading: isLoadingUser,
  } = useUserQuery({ username: String(username) }, { skip: !username })

  return (
    <>
      <PageTitle text={t("pageTitles.ACCOUNT_SETTINGS")} styles={{ mb: 2 }} />
      <LinkTabsSection tabsConfig={accountSettingsTabsConfig} />
      <Outlet context={{ user, isLoadingUser, isErrorUser }} />
    </>
  )
}

export default AccountSettings
